import { SectionHead, FadeUp } from "@/components/site/Reveal";
import { AREAS } from "@/data/site";

const GUIDE = [
  { h: "Choosing the right wire size", p: "For lighting circuits in Mumbai homes, 1.0 to 1.5 sq mm copper FR wire is standard. Power sockets and geysers usually need 2.5 to 4 sq mm, and ACs need 4 sq mm. FRLS and ZHFR cables add fire safety for flats and offices." },
  { h: "Why BLDC fans pay for themselves", p: "A BLDC ceiling fan uses around 28 to 35 watts against 75 watts for a regular fan. Running through the long Mumbai summer, that saving often covers the price difference within two years." },
  { h: "MCB vs RCCB: you need both", p: "MCBs protect your wiring from overload and short circuits. RCCBs protect people from electric shock by tripping on earth leakage. A safe distribution board uses both." },
];

export const Guide = () => (
  <section className="px-6 py-28" data-testid="guide-section">
    <div className="mx-auto max-w-7xl">
      <SectionHead eyebrow="04 / Buying guide" title={["Expert tips from", "our counter."]} text="Practical advice from the Rama Electricals team to help you buy the right electrical products for your home or project." />
      <div className="mt-14 grid md:grid-cols-3 gap-px bg-white/10 rounded-3xl overflow-hidden border border-white/10">
        {GUIDE.map((g, i) => (
          <FadeUp key={g.h} delay={i * 0.1} as="article" className="bg-[#050B1A] p-8 md:p-10">
            <p className="font-mono text-xs text-[#39FF14]">0{i + 1}</p>
            <h3 className="font-display text-2xl mt-6">{g.h}</h3>
            <p className="mt-4 text-[#a5b4c8] leading-relaxed text-sm md:text-base">{g.p}</p>
          </FadeUp>
        ))}
      </div>
      <FadeUp className="mt-12 flex flex-wrap gap-2">
        <span className="eyebrow mr-3 self-center">Areas we serve</span>
        {AREAS.map((a) => <span key={a} className="rounded-full border border-white/15 px-4 py-2 text-sm text-slate-300">{a}</span>)}
      </FadeUp>
    </div>
  </section>
);
